import { render } from "./IconDevs.vue?vue&type=template&id=6a930d4b"
const script = {}

import exportComponent from "/builds/enrian/design/design-system-documentation/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__